const SERIES={vehicle:25471, property_market:25497, property_regulated:25498};
const fmt=d=>{const [y,m,day]=d.split('-'); return `${day}/${m}/${y}`};
export async function getBcbRate(kind,date){
  const code=SERIES[kind]; if(!code||!date) return null;
  const dt=new Date(`${date}T12:00:00`);
  const start=new Date(dt.getFullYear(),dt.getMonth(),1);
  const end=new Date(dt.getFullYear(),dt.getMonth()+1,0);
  const toIso=x=>`${x.getFullYear()}-${String(x.getMonth()+1).padStart(2,'0')}-${String(x.getDate()).padStart(2,'0')}`;
  const url=`https://api.bcb.gov.br/dados/serie/bcdata.sgs.${code}/dados?formato=json&dataInicial=${encodeURIComponent(fmt(toIso(start)))}&dataFinal=${encodeURIComponent(fmt(toIso(end)))}`;
  const res=await fetch(url);
  if(!res.ok) throw new Error('BACEN indisponível no momento');
  const data=await res.json();
  if(!Array.isArray(data)||!data.length) return null;
  return {series:code,date:data.at(-1).data,value:Number(String(data.at(-1).valor).replace(',','.'))};
}
export {SERIES};